//import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth, UserType } from '../context/AuthContext';
import { ROUTES } from '../routes/routes';
import { RouteConfig } from '../types/routeConfigType';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';




//import useDeviceType from '../hooks/useDeviceType';

const Menu = () => {
    const { user, logout, login: authenticateUser } = useAuth();
    const [isNavbarCollapsed, setIsNavbarCollapsed] = useState(true);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const navigate = useNavigate();


    if (!user) return null;

    //Revisamos si estamos impersonando
    const isImpersonating = !!localStorage.getItem('userAdmin');

    const menuOptions = ROUTES[user.User.role] || []
    //const menuOptions = ROUTES['Supervisor de Taller'] || []


    const stopImpersonation = async () => {
        try {
            const storedUserAdmin = localStorage.getItem('userAdmin');

            if (storedUserAdmin) {
                const userAdmin: UserType = JSON.parse(storedUserAdmin);
    
                authenticateUser(userAdmin);
                localStorage.removeItem('userAdmin');
                //sessionStorage.removeItem('userAdmin');
            }
            //window.location.reload();
            navigate('/');
        } catch (error: any) {
            console.log('Error al detener impersonar', error.message);
        }
       
    }

    return (
        <div className='navbar navbar-expand-lg navbar-dark bg-dark d-print-none sticky-top'>
            <div className='container-fluid'>
                <Link className='navbar-brand' to='/'>Home</Link>
                <button className='navbar-toggler'
                    style={{ padding: '0.25rem 0.75rem' }}
                    type='button'
                    data-bs-toggle='collapse'
                    data-bs-target="#navbarNav"
                    aria-controls='navbarNav'
                    aria-expanded={!isNavbarCollapsed}
                    aria-label='Toggle Navigation'
                    onClick={() => setIsNavbarCollapsed(!isNavbarCollapsed)}>
                    <span className='navbar-toggler-icon'></span>
                </button>
                <div className={`collapse navbar-collapse ${isNavbarCollapsed ? '' : 'show'}`} id='navbarNav'>
                    <ul className='navbar-nav ms-auto'>
                        {/* {routes.map((route) => (
                            <li className='nav-item' style={{ margin: '0 10px' }} key={route.path}>
                                <Link className='nav-link'
                                    to={route.path}
                                    onClick={handleLinkClick}
                                >
                                    {route.label}
                                </Link>
                            </li>
                        ))} */}
                        {/* <li><button className='btn btn-danger' onClick={logout}>Cerrar Sesión</button></li> */}
                        {menuOptions.map((route, index) => (
                            <MenuItem key={index} route={route} />
                        ))}
                        {user && (
                            <li className='nav-item dropdown bg-dark'>
                                <button
                                    className='btn btn-light dropdown-toggle'
                                    id="userDropdown"
                                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                    aria-expanded={isDropdownOpen}
                                    data-bs-toggle="dropdown"
                                    data-bs-display="static"
                                >
                                    <i className="fas fa-user-circle me-2"></i> {user.User.name}
                                </button>
                                <ul className={`dropdown-menu dropdown-menu-end shadow  ${isDropdownOpen ? 'show' : ''}`} aria-labelledby='userDropdown'>
                                    <li><span className="dropdown-item-text fw-bold">{user.User.name}</span></li>
                                    <li><span className="dropdown-item-text">{user.User.email}</span></li>
                                    <li><span className="dropdown-item-text text-muted"><small className='text-muted'>Puesto: {user.User.position}</small></span></li>
                                    <li><span className="dropdown-item-text text-muted"><small className='text-muted'>Role: {user.User.role}</small></span></li>
                                    <li><hr className="dropdown-divider" /></li>
                                    {isImpersonating && (
                                        <li>
                                            <button
                                                className="dropdown-item text-primary text-center"
                                                onClick={stopImpersonation}
                                            >
                                                Salir Impersonar
                                            </button>
                                        </li>
                                    )}
                                    <li><button className="dropdown-item text-danger text-center" onClick={logout}>Cerrar Sesión</button></li>
                                </ul>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        </div>
    );
};


const MenuItem = ({ route }: { route: RouteConfig }) => {
    if (route.children) {
        //console.log('En el menu si hay children: ', route.children)
        return (
            <li className="nav-item dropdown" data-bs-theme="dark">
                <a className="nav-link dropdown-toggle" href={`${route.path}`} id={`dropdown-${route.path}`} role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i className={`me-2 ${route.icon}`}></i> {route.label}
                </a>
                <ul className="dropdown-menu" aria-labelledby={`dropdown-${route.path}`}>
                    {route.children.map((child, index) => (
                        <li key={index}>
                            <Link to={child.path ? child.path : ''} className="dropdown-item" id={`link-${child.path?.substring(1)}`} >
                                {child.label}
                            </Link>
                        </li>
                    ))}
                </ul>
            </li>
        )
    }
    return (
        <li className="nav-item">
            <Link className="nav-link" to={route.path ? route.path : ''}>
                <i className={`me-2 ${route.icon}`}></i>{route.label}
            </Link>
        </li>
    );
};

export default Menu;